import { Box, Card, CardContent, CardHeader, CardMedia, Grid2, Stack, Typography } from '@mui/material'
import OrgSummary from '../components/OrgSummary'
import RfqsList from '../components/RfqsList'
import { IncomePlot } from '../components/dashboard/IncomePlot'
import OutstandingCommission from '../components/dashboard/OutstandingCommission'
import ProjectsCard from '../components/dashboard/ProjectsCard'
import { DashboardContextProvider } from '../contexts/DashboardContextProvider'
import { RfqStatus } from '../gql/graphql'
import { useDocumentTitle } from '../hooks/useDocumentTitle'

export default function HomePage() {
  useDocumentTitle('Home')

  return (
    <DashboardContextProvider>
      <Box>
        <Typography variant="h1">Hello!</Typography>
        <Grid2 container my={4} spacing={4}>
          <Grid2 size={{ xs: 12, md: 8 }}>
            <Stack spacing={4}>
              <ProjectsCard />

              <Card>
                <CardContent>
                  <Typography gutterBottom variant="h5">
                    Unquoted RFQs
                  </Typography>
                </CardContent>
                <CardMedia>
                  <RfqsList
                    boxProps={{ sx: { height: '300px' } }}
                    gridProps={{ borderless: true }}
                    filters={{ statuses: [RfqStatus.New] }}
                  />
                </CardMedia>
              </Card>
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 4 }}>
            <Stack spacing={4}>
              <OutstandingCommission />
              <Card>
                <CardHeader title="Income" />
                <CardContent sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <IncomePlot />
                </CardContent>
              </Card>
              <Card>
                <CardContent>
                  <Typography gutterBottom variant="h5">
                    Organization Summary
                  </Typography>
                  <OrgSummary sx={{ maxWidth: 200 }} />
                </CardContent>
              </Card>
            </Stack>
          </Grid2>
        </Grid2>
      </Box>
    </DashboardContextProvider>
  )
}
